import {PRIVACY_ACCEPTED} from "../consants/config";

export const isPrivacyAccepted = (): boolean => localStorage.getItem(PRIVACY_ACCEPTED) === "true";